import { Esqueleto } from '../../../components/Estados'
import { TEXTOS } from '../../../lib/glossario'
import { dataHora } from '../../../lib/datas'
import type { RevisaoDePr } from '../../../types/gmud'

/**
 * As revisões de código dos PRs que citam a solicitação, com o veredito do Copilot.
 *
 * Saiu de `PainelDeApoioDoComite` quando os commits da branch principal entraram no painel: o
 * teto de 200 linhas por arquivo é o que impede o painel de virar a Blade de 1119 linhas.
 */
export function RevisoesDeCodigo({
  revisoes,
  carregando,
  indisponibilidade,
}: {
  revisoes: RevisaoDePr[]
  carregando: boolean
  /** O que falta para a integração funcionar, quando ela está desligada. */
  indisponibilidade: string | null
}) {
  return (
    <div className="border-t border-slate-200 pt-3">
      <h3 className="text-sm font-medium text-slate-700">{TEXTOS.apoioAoComite.revisaoDeCodigo}</h3>
      <p className="mt-0.5 text-xs text-slate-500">{TEXTOS.apoioAoComite.revisaoAjuda}</p>
      {carregando && <Esqueleto linhas={1} />}
      {/* Com a integração desligada, "nenhum PR encontrado" seria mentira por omissão: o comitê
          leria ausência de revisão como código sem pendência, quando ninguém foi procurar. */}
      {!carregando && indisponibilidade && (
        <p className="mt-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-slate-700">
          {indisponibilidade}
        </p>
      )}
      {!carregando && !indisponibilidade && revisoes.length === 0 && (
        <p className="mt-2 text-sm text-slate-500">{TEXTOS.apoioAoComite.semRevisao}</p>
      )}
      <ul className="mt-2 space-y-2">
        {revisoes.map((r) => (
          <li key={r.id} className="rounded-md border border-slate-200 p-3 text-sm">
            <p>
              <a
                href={r.prUrl}
                target="_blank"
                rel="noreferrer"
                className="font-medium text-niteroi-700 underline underline-offset-2 hover:text-niteroi-900"
              >
                {r.repositorio}#{r.prNumero}
              </a>{' '}
              — {r.prTitulo}
              {r.prMescladoEm && (
                <span className="ml-2 inline-flex rounded-full bg-slate-200 px-2 py-0.5 text-xs text-slate-700">
                  {TEXTOS.apoioAoComite.mesclado} em {dataHora(r.prMescladoEm)}
                </span>
              )}
            </p>
            {r.revisaoResumo ? (
              <p className="mt-1 whitespace-pre-line text-slate-600">{r.revisaoResumo}</p>
            ) : (
              <p className="mt-1 text-slate-500">{TEXTOS.apoioAoComite.semRevisaoDoCopilot}</p>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}

